import findIndex from 'lodash/findIndex';
import max from 'lodash/max';
import pull from 'lodash/pull';

type ListingWithId = {
  maloneLotIdEncoded: string;
};

const findListingIndex = (listingGroups: Array<ListingWithId>, listing: ListingWithId): number => {
  return findIndex(listingGroups, (currentListing) => {
    return currentListing.maloneLotIdEncoded === listing.maloneLotIdEncoded;
  });
};

// same as above but will return 0 if it does not find an index instead of -1
const getCurrentListingIndex = (list: Array<ListingWithId>, currentListing: ListingWithId): number => {
  return max([findListingIndex(list, currentListing), 0]) as number;
};

const updateUserItemTypes = (userItemTypes: Array<string>, action: string, type: string): Array<string> => {
  if (action === 'add') {
    if (userItemTypes.indexOf(type) === -1) {
      userItemTypes.push(type);
    }
  } else {
    userItemTypes = pull(userItemTypes, type);
  }
  return ([] as Array<string>).concat(userItemTypes);
};

export { findListingIndex, updateUserItemTypes, getCurrentListingIndex };
